import React from 'react'
import { Role } from '../../../../../Models/AdminManagement'
import './RoleCheckList.scss'

interface RoleCheckListProps {
  roles: Role[]
  value: string[]
  onChange: (roleNames: string[]) => void
  disabled?: boolean
  idPrefix?: string
}

// Since a user can hold several roles, we use a multi-select checklist.
const RoleCheckList: React.FC<RoleCheckListProps> = ({
  roles,
  value,
  onChange,
  disabled = false,
  idPrefix = 'role',
}) => {
  const toggle = (name: string) => {
    onChange(value.includes(name) ? value.filter((n) => n !== name) : [...value, name])
  }

  if (roles.length === 0) {
    return <div className='text-muted small'>No roles defined yet.</div>
  }

  return (
    <div className='RoleCheckList row'>
      {roles.map((role) => (
        <div key={role.id} className='role-item col-md-6 mb-2'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='checkbox'
              id={`${idPrefix}-${role.id}`}
              checked={value.includes(role.name)}
              disabled={disabled}
              onChange={() => toggle(role.name)}
            />
            <label className='form-check-label' htmlFor={`${idPrefix}-${role.id}`}>
              <div className='role-name'>{role.name}</div>
              {role.description && <div className='role-desc'>{role.description}</div>}
            </label>
          </div>
        </div>
      ))}
    </div>
  )
}

export default RoleCheckList
